<template>
    <div class="pd-page">
        <div class="pd-page-header">轴承加工-MES系统</div>
        <div class="pd-page-body">
            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>企业类型
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>机加</li>
                    </ul>
                </div>
            </div>

            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>客户介绍
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>某轴承公司位于辽宁省大连瓦房店市，始建于1994年10月，占地面积12万平方米，建筑面积6万平方米，固定资产2亿元，拥有各种专业生产检测设备500余台，员工500余人，年产值3亿元，能够生产8大类型，3个精度等级4000多个规格的各种用途轴承。</li>
                    </ul>
                </div>
            </div>

            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>客户痛点
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>库存周转天偏高</li>
                        <li>受加工精度稳定影响，合套生产计划管理复杂。</li>
                        <li>过程质量损失较高</li>
                        <li>设备稳定性差</li>
                        <li>生产成本核算以财务月度结算为准，误差大，无法精确到批次和单个产品。 </li>
                        <li>车间负责人需要每天统计进度，管理效率低。</li>
                    </ul>
                </div>
            </div>

            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>解决方案
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>改进生产管理：精益生产过程管理，生产数据采集，快速定位生产瓶颈，为生产调度提供执行依据</li>
                        <li>优化图纸管理方式：实现多环节多图纸上传、保留变更履历等，提升图纸变化传递时效性 </li>
                        <li>车间智能终端管理：实现作业指导在线浏览，无需下发纸质单据，实现“无纸化作业” </li>
                        <li>废品智能推荐：将新产品与废品库做参数比对，按匹配度智能推荐报废品进行优先改制</li>
                        <li>绩效自动核算：利用PAD派工、执行、报工，结合绩效考核，实现工人工资自动核算</li>
                        <li>设备管理：实时查看设备运行状态。设备报警管理、设备维修管理</li>
                        <li>成本核算：生产成本的归集与分摊管理的模式</li>
                        <li>现场可视化看板：监控车间生产、质量、设备等状态信息，是监视车间KPI指标的“仪表盘</li>
                    </ul>
                </div>
            </div>

            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>应用价值
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>打通生产制造全流程：异常反应及处理效率提升70%以上</li>
                        <li>强化成本控制：减少废品滞留库存，降低生产成本20%以上 </li>
                        <li>无纸化办公：实现数据实时采集、实时共享，节省数据报表统计时间70%以上 </li>
                        <li>全厂资源信息整合：实现数据在全厂范围保持一致，消除数据分歧，提升准确性 </li>
                        <li>建立并提升了移动办公及协调管理能力</li>
                        <li>为公司领导层提供大数据辅助决策，提升决策效率10%以上</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "casePage2"
}
</script>

<style scoped>

</style>
